import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { routerPath } from "@config";
import { selectApplicationGeneralInfo, selectCurrentApplicationData, selectCurrentApplicationEsgRiskLevel } from "@redux/Selectors";
import { i18, trb } from "@utilities";
import { TitleCardListItem } from "../Elements/TitleCardListItem";

import "./TitleCard.less";
import { Button } from "antd";
import { history } from "@config";
import { ApplicationsActions } from "../../../Redux";

export const TitleCard = React.memo((props) => {
  const appInfo = useSelector(selectApplicationGeneralInfo);
  const currentAppInfo = useSelector(selectCurrentApplicationData);
  const appEsgRiskLevel = useSelector(selectCurrentApplicationEsgRiskLevel);
  const dispatch = useDispatch();
  const [canResetClient, setCanResetClient] = useState(false);
  const [canRetryPrefill, setCanRetryPrefill] = useState(false);

  async function handleReset() {
    if (canResetClient) {
      const applicationId = history.location.pathname.split('/')[2]
      await dispatch(ApplicationsActions.renewKyc(applicationId))
        .then(res => res.type === 'RENEW_KYC_SUCCESS' && history.push('/kycApplications'))
    }
  }

  async function handlePrefillRetry() {
    if (canRetryPrefill) {
      const applicationId = history.location.pathname.split('/')[2]
      await dispatch(ApplicationsActions.retryPrefill(applicationId))
        .then(res => res.type === 'RETRY_PREFILL_SUCCESS' && history.push('/kycApplications'))
    }
  }

  useEffect(() => {
    if (appInfo.currentState === 'OnboardingComplete' || appInfo.currentState === 'RenewedKycCompleted') {
      setCanResetClient(prevState => prevState = true);
    }

    if(appInfo.currentState === 'Registered') {
      setCanRetryPrefill(prevState => prevState = true);
    }

  }, [setCanResetClient], [setCanRetryPrefill])

  return (
    <div className="d-flex kyc-application-container-card">
      <div className="back-container">
        <Link to={routerPath.listKyc}>
          <ArrowLeftOutlined className="back-btn" />
        </Link>
      </div>
      <div className="content-container">
        <TitleCardListItem title={trb(i18.Labels.CompanyName)} info={appInfo.clientName} />
        <TitleCardListItem title={trb(i18.Labels.CompanyCode)} info={appInfo.code} />
        <TitleCardListItem title={trb(i18.Labels.CompanyState)} info={appInfo.currentState} />
        <TitleCardListItem title={trb(i18.Labels.CompanyStatus)} info={appInfo.currentStatus} />
        <TitleCardListItem title={trb(i18.Labels.PhoneNumber)} info={currentAppInfo?.clientPhone[0]?.data?.clientPhoneNo ?? 'N/A'} />
        <TitleCardListItem title="ESG Risk Level" info={appEsgRiskLevel ?? 'N/A'} />
        {canResetClient &&
          <Button
            onClick={handleReset}
            type="primary"
            size="middle"
          >
            Start periodic Review
          </Button>
        }  
        {canRetryPrefill &&
          <Button
            onClick={handlePrefillRetry}
            type="primary"
            size="middle"
          >
            Retry prefill
          </Button>
        }
      </div>
    </div>
  );
});
